import { DefaultButton, Dialog, DialogFooter, PrimaryButton, IDialogContentProps, IIconProps } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  isLoading?: boolean;
  dialogContentProps: IDialogContentProps;
  onSuccess: () => void;
  onCancel: () => void;
  confirmBtnText?: string;
  isConfirmDisabled?: boolean;
}

const ConfirmationModal = (props: Props) => {
  const { t } = useTranslation();
  const iconProps: IIconProps = props.isLoading ? {
    iconName: 'ProgressRingDots',
    className: 'spin',
  } : {};

  return (
    <Dialog
      hidden={false}
      onDismiss={props.onCancel}
      dialogContentProps={props.dialogContentProps}
    >
      {props.dialogContentProps?.children || null}
      <DialogFooter>
        <PrimaryButton
          onClick={props.onSuccess}
          disabled={props.isLoading || props.isConfirmDisabled}
          iconProps={iconProps}
          text={props.confirmBtnText || t('common:confirm')}
        />
        <DefaultButton
          onClick={props.onCancel}
          disabled={props.isLoading}
          text={t('common:cancel')}
        />
      </DialogFooter>
    </Dialog>
  )
};

export default ConfirmationModal;
